import React from 'react';
import { useTranslation } from 'react-i18next';

import { cls } from '@mssgme/helpers';
import { LabelProps } from './types';

import styles from './Label.scss';

export default function Label({ disabled, required, optional, builderInput, children, ...props }) {
    const { t } = useTranslation('ui');
    const mark = required ? (
        <span className={styles.requiredMark} title={t('labels.field_required')}>
            *
        </span>
    ) : (
        optional && (
            <span className={styles.optionalMark} title={t('labels.field_optional')}>
                {t('labels.optional')}
            </span>
        )
    );

    return (
        <label {...cls([styles.root, builderInput && styles.builderStyle, disabled && styles.disabled], props)}>
            {children}
            {mark}
        </label>
    );
}

Label.propTypes = LabelProps;

Label.styles = styles;
